// TODO(tsgo): Remove when microsoft/typescript-go#1034 is fixed (check after tsgo 7.1+)
import { createDispute } from "./schema/disputes/create-dispute";
import { generateDisputeEmail } from "./schema/disputes/generate-dispute-email";
import { getDisputes } from "./schema/disputes/get-disputes";
import { updateDisputeStatus } from "./schema/disputes/update-dispute-status";
import { addItemsToPurchaseOrder } from "./schema/purchase-orders/add-items-to-purchase-order";
import { addPurchaseOrderFile } from "./schema/purchase-orders/add-purchase-order-file";
import { bulkDeletePurchaseOrders } from "./schema/purchase-orders/bulk-delete-purchase-orders";
import { bulkUpdatePurchaseOrders } from "./schema/purchase-orders/bulk-update-purchase-orders";
import { cancelPoUpload } from "./schema/purchase-orders/cancel-po-upload";
import { createPurchaseOrder } from "./schema/purchase-orders/create-purchase-order";
import { createPurchaseOrderShipment } from "./schema/purchase-orders/create-purchase-order-shipment";
import { deletePurchaseOrder } from "./schema/purchase-orders/delete-purchase-order";
import { deletePurchaseOrderFile } from "./schema/purchase-orders/delete-purchase-order-file";
import { generatePurchaseOrderPdf } from "./schema/purchase-orders/generate-purchase-order-pdf";
import { getOpenPurchaseOrdersForProductFamilies } from "./schema/purchase-orders/get-open-purchase-orders-for-product-families";
import { getPackingTemplatesForProduct } from "./schema/purchase-orders/get-packing-templates-for-product";
import { getPurchaseOrder } from "./schema/purchase-orders/get-purchase-order";
import { getPurchaseOrderTags } from "./schema/purchase-orders/get-purchase-order-tags";
import { getPurchaseOrders } from "./schema/purchase-orders/get-purchase-orders";
import { getPurchaseOrdersByIds } from "./schema/purchase-orders/get-purchase-orders-by-ids";
import { updatePurchaseOrder } from "./schema/purchase-orders/update-purchase-order";
import { updateShipmentProducts } from "./schema/purchase-orders/update-shipment-products";
import { uploadPurchaseOrders } from "./schema/purchase-orders/upload-purchase-orders";
import { uploadPurchaseOrdersCsv } from "./schema/purchase-orders/upload-purchase-orders-csv";
import { watchPoUploadJobs } from "./schema/purchase-orders/watch-po-upload-jobs";
import { addShipmentFile } from "./schema/shipments/add-shipment-file";
import { bulkDeleteShipments } from "./schema/shipments/bulk-delete-shipments";
import { bulkUpdateShipments } from "./schema/shipments/bulk-update-shipments";
import { createShipment } from "./schema/shipments/create-shipment";
import { deleteShipment } from "./schema/shipments/delete-shipment";
import { deleteShipmentFile } from "./schema/shipments/delete-shipment-file";
import { getShipment } from "./schema/shipments/get-shipment";
import { getShipments } from "./schema/shipments/get-shipments";
import { linkShipmentToPurchaseOrder } from "./schema/shipments/link-shipment-to-purchase-order";
import { unlinkShipmentFromPurchaseOrder } from "./schema/shipments/unlink-shipment-from-purchase-order";
import { updateShipment } from "./schema/shipments/update-shipment";
import { updateShipmentProductPacking } from "./schema/shipments/update-shipment-product-packing";

export const groupD = {
  bulkDeletePurchaseOrders,
  bulkUpdatePurchaseOrders,
  bulkDeleteShipments,
  bulkUpdateShipments,
  addItemsToPurchaseOrder,
  addPurchaseOrderFile,
  createPurchaseOrder,
  createPurchaseOrderShipment,
  deletePurchaseOrder,
  deletePurchaseOrderFile,
  generatePurchaseOrderPdf,
  getOpenPurchaseOrdersForProductFamilies,
  getPackingTemplatesForProduct,
  getPurchaseOrder,
  getPurchaseOrderTags,
  getPurchaseOrders,
  getPurchaseOrdersByIds,
  updatePurchaseOrder,
  updateShipmentProducts,
  addShipmentFile,
  createShipment,
  deleteShipment,
  deleteShipmentFile,
  getShipment,
  getShipments,
  linkShipmentToPurchaseOrder,
  unlinkShipmentFromPurchaseOrder,
  updateShipment,
  updateShipmentProductPacking,
  createDispute,
  generateDisputeEmail,
  getDisputes,
  updateDisputeStatus,
  uploadPurchaseOrders,
  uploadPurchaseOrdersCsv,
  watchPoUploadJobs,
  cancelPoUpload,
};
